module.exports = __webpack_public_path__ + "static/img/question4-6.64f76ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question4-6.png
// module id = EqiG
// module chunks = 1